import React, { useEffect, useState } from 'react'
import NewJournalEntry from './NewJournalEntry'
import JournalEntry from './JournalEntry'
// import {withJournalEntriesApi} from "../../../apis/journal_entries_api"

const JournalEntryThread = props => {
  const isReply = props.isReply
  const [thread, setThread] = useState(props.thread)
  // const label = isReply ? 'Reply' : 'JournalEntry'
  const [isGettingJournalEntries, setIsGettingJournalEntries] = useState(false)
  const [showJournalEntryThread, setShowJournalEntryThread] = useState(true)
  const [showNewJournalEntry, setShowNewJournalEntry] = useState(false)

  useEffect(() => {
    if (!isGettingJournalEntries && !thread) {
      setIsGettingJournalEntries(true)
      props.journalEntriesActions?.getJournalEntries(props.goalId, props.taskId, (data) => {
        setThread(data)
        setIsGettingJournalEntries(false)
      })
    }
  })

  const saveNewJournalEntry = (content, cb) => {
    props.journalEntriesActions.createJournalEntry(content, props.goalId, props.taskId, cb)
  }

  // const updateJournalEntry = () => {
  //
  // }

  const setShowBothJournalEntryAndThread = (newShowNewJournalEntry) => {
    if (newShowNewJournalEntry && !showJournalEntryThread) { setShowJournalEntryThread(true) }
    setShowNewJournalEntry(newShowNewJournalEntry)
  }

  return (<div>
    {!props.editing &&
      <>
        {props.content}
        <i
          className={`icon-button margin-left fas ${isReply ? 'fa-reply' : 'fa-comment'}`}
          onClick={() => setShowBothJournalEntryAndThread(!showNewJournalEntry)}
        />
        {thread && thread.length > 0 &&
          <i
            className="icon-button margin-left fas fa-comments"
            onClick={() => setShowJournalEntryThread(!showJournalEntryThread)}
          />}
      </>}
    {props.children}
    {showJournalEntryThread &&
      <>
        {showNewJournalEntry &&
          <NewJournalEntry
            hideNewJournalEntry={() => setShowNewJournalEntry(false)}
            goalId={props.goalId}
            taskId={props.taskId}
            saveNewJournalEntry={saveNewJournalEntry}
          />}
        {thread?.map((t, i) => (
          <div key={i} style={{ marginLeft: '8.33%' }}> <JournalEntry goalId={props.goalId} taskId={props.taskId} journalEntry={t} /> </div>
        ))}
        {(!thread || thread.length === 0) && <div><font size={-1}><i>No comments yet.</i></font></div>}
      </>}
  </div>)
}

export default JournalEntryThread
